/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitHostingRegionResult } from './MonitHostingRegionResult';
import {
    MonitHostingRegionResultFromJSON,
    MonitHostingRegionResultFromJSONTyped,
    MonitHostingRegionResultToJSON,
} from './MonitHostingRegionResult';

/**
 * 
 * @export
 * @interface MonitHostingProviderResult
 */
export interface MonitHostingProviderResult {
    /**
     * 
     * @type {number}
     * @memberof MonitHostingProviderResult
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitHostingProviderResult
     */
    provider?: string;
    /**
     * 
     * @type {Array<MonitHostingRegionResult>}
     * @memberof MonitHostingProviderResult
     */
    regions?: Array<MonitHostingRegionResult>;
}

/**
 * Check if a given object implements the MonitHostingProviderResult interface.
 */
export function instanceOfMonitHostingProviderResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitHostingProviderResultFromJSON(json: any): MonitHostingProviderResult {
    return MonitHostingProviderResultFromJSONTyped(json, false);
}

export function MonitHostingProviderResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitHostingProviderResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'regions': !exists(json, 'regions') ? undefined : ((json['regions'] as Array<any>).map(MonitHostingRegionResultFromJSON)),
    };
}

export function MonitHostingProviderResultToJSON(value?: MonitHostingProviderResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'provider': value.provider,
        'regions': value.regions === undefined ? undefined : ((value.regions as Array<any>).map(MonitHostingRegionResultToJSON)),
    };
}

